import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "../../_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
let { Store } = configureStore();
// import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const DepartmentService = {
  getDepartment,
  getDepartmentByID,
  createDepartment,
  updateDepartment,
  deleteDepartment,
};

export async function getDepartment(filter) {
  const url = "/user-management/departments?" + (filter || "");
  try {
    const departmentData = Store.getState()?.userManagement?.department;
    if ((Array.isArray(departmentData) && departmentData.length === 0) || filter) {
      const response = await RestMethod.GET(url);
      Store.dispatch({
        type: USER_DATA_CONSTANT.DEPARTMENT,
        data: response,
      });
      return response.data;
    } else {
      return {
        status: 1,
        message: "Data from store",
        data: departmentData,
      };
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getDepartmentByID(id) {
  try {
    const response = await RestMethod.GET("/user-management/departments/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function createDepartment(data) {
  try {
    const response = await RestMethod.POST("/user-management/departments", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateDepartment(id, data) {
  try {
    const response = await RestMethod.PUT("/user-management/departments/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function deleteDepartment(id, data) {
  try {
    const response = await RestMethod.DELETE("/user-management/departments/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
